import { loggerManager } from '..';

/**
 * 打印 document.visibilityState
 * 背景：移动端设备中，当页面切后台时，采集可能会暂停，track muted
 * 目的：为识别是否是由于切后台导致的采集暂停，在出现 track muted 打印 visibilityState
 * 调用时机：出现 track muted 时
 */
export const logVisibilityState = (() => {
  let isListened = false;
  let preLoggedVisibilityState = document.visibilityState;
  return () => {
    // 若只依赖于监听事件打印日志，可能第一次调用该接口时，会漏掉一次日志。
    if (document.visibilityState !== preLoggedVisibilityState) {
      loggerManager.info(`visibility change: ${document.visibilityState}`);
    }
    // 避免重复监听事件。
    if (isListened) {
      return;
    }
    // iOS 设备中，切后台时，track muted 会比 visibilitychange 先触发。
    // 导致在 track muted 时直接打印 visibility 会是 visible 状态，但是已经切后台了。
    // 因此，需要监听 visibilitychange 事件来打印。
    document.addEventListener('visibilitychange', () => {
      loggerManager.info(`visibility change: ${document.visibilityState}`);
      preLoggedVisibilityState = document.visibilityState;
    });
    isListened = true;
  };
})();
